import React from 'react';
import DDTeam from '../components/Team/DDTeam';
import ProjectTeamAccess from '../components/TeamAccess/ProjectTeamAccess';
import Pageheader from '../utils/headerHelment';
import { useParams } from 'react-router';

const TeamView = () => {
    const params = useParams();
    return params?.type === 'dd' ? <DDTeams /> : <VDRTeams />;
};

const VDRTeams = () => (
    <>
        <Pageheader title="LENS - Team" />
        <ProjectTeamAccess />
    </>
);

const DDTeams = () => (
    <>
        <Pageheader title="LENS - Team" />
        <DDTeam />
    </>
);

export default TeamView;
